 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import GROVEATLANTICLITHUB from '@/components/groveatlanticlithub'
 import LOVE_1 from '@/components/love_1'
 import EBOOK4351 from '@/components/eBook4351'
 import EBOOK43511 from '@/components/eBook43511'
 import EBOOK43512 from '@/components/eBook43512'
 import EBOOK43513 from '@/components/eBook43513'
 import EBOOK43514 from '@/components/eBook43514'
 import EBOOK43515 from '@/components/eBook43515'
 import EBOOK43516 from '@/components/eBook43516'
 import EBOOK43517 from '@/components/eBook43517'
 import EBOOK43518 from '@/components/eBook43518'
 import EBOOK43519 from '@/components/eBook43519'
 import EBOOK435110 from '@/components/eBook435110'
 import EBOOK435111 from '@/components/eBook435111'
 import EBOOK435112 from '@/components/eBook435112'
 import EBOOK435113 from '@/components/eBook435113'
 import EBOOK435114 from '@/components/eBook435114'
 import EBOOK435115 from '@/components/eBook435115'
 import EBOOK435116 from '@/components/eBook435116'
 import EBOOK435117 from '@/components/eBook435117'
 import EBOOK435118 from '@/components/eBook435118'
 import EBOOK435119 from '@/components/eBook435119'
 import EBOOK435120 from '@/components/eBook435120'
 import EBOOK435121 from '@/components/eBook435121'
 import EBOOK435122 from '@/components/eBook435122'
 import EBOOK435123 from '@/components/eBook435123'
 import EBOOK435124 from '@/components/eBook435124'
 import EBOOK435125 from '@/components/eBook435125'
 import EBOOK435126 from '@/components/eBook435126'
 import EBOOK435127 from '@/components/eBook435127'
 import EBOOK435128 from '@/components/eBook435128'
 import EBOOK435129 from '@/components/eBook435129'
 import EBOOK435130 from '@/components/eBook435130'
 import EBOOK435131 from '@/components/eBook435131'
 import EBOOK435132 from '@/components/eBook435132'
 import EBOOK435133 from '@/components/eBook435133'
 import EBOOK435134 from '@/components/eBook435134'
 import EBOOK435135 from '@/components/eBook435135'
 import EBOOK435136 from '@/components/eBook435136'
 import EBOOK435137 from '@/components/eBook435137'
 import EBOOK435138 from '@/components/eBook435138'
 import EBOOK435139 from '@/components/eBook435139'
 import EBOOK435140 from '@/components/eBook435140'
 import EBOOK435141 from '@/components/eBook435141'
 import EBOOK435142 from '@/components/eBook435142'
 import EBOOK435143 from '@/components/eBook435143'
 import EBOOK435144 from '@/components/eBook435144'
 import EBOOK435145 from '@/components/eBook435145'
 import EBOOK435146 from '@/components/eBook435146'
 import EBOOK435147 from '@/components/eBook435147'
 import EBOOK435148 from '@/components/eBook435148'
 import EBOOK435149 from '@/components/eBook435149'
 import EBOOK435150 from '@/components/eBook435150'
 import EBOOK435151 from '@/components/eBook435151'
 import EBOOK435152 from '@/components/eBook435152'
 import EBOOK435153 from '@/components/eBook435153'
 import EBOOK435154 from '@/components/eBook435154'
 import EBOOK435155 from '@/components/eBook435155'
 import EBOOK435156 from '@/components/eBook435156'
 import EBOOK435157 from '@/components/eBook435157'
 import EBOOK435158 from '@/components/eBook435158'
 import EBOOK435159 from '@/components/eBook435159'
 import EBOOK435160 from '@/components/eBook435160'
 import EBOOK435161 from '@/components/eBook435161'
 import EBOOK435162 from '@/components/eBook435162'
 import EBOOK435163 from '@/components/eBook435163'
 import EBOOK435164 from '@/components/eBook435164'
 import EBOOK435165 from '@/components/eBook435165'
 import EBOOK435166 from '@/components/eBook435166'
 import EBOOK435167 from '@/components/eBook435167'
 import EBOOK435168 from '@/components/eBook435168'
 import EBOOK435169 from '@/components/eBook435169'
 import EBOOK435170 from '@/components/eBook435170'
 import EBOOK435171 from '@/components/eBook435171'
 import EBOOK435172 from '@/components/eBook435172'
 import EBOOK435173 from '@/components/eBook435173'
 import EBOOK435174 from '@/components/eBook435174'
 import EBOOK435175 from '@/components/eBook435175'
 import LOVE_2 from '@/components/love_2'
 import EBOOK435176 from '@/components/eBook435176'
 import EBOOK435177 from '@/components/eBook435177'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/groveatlanticlithub",
 			"name" : "groveatlanticlithub",
 			"component" : GROVEATLANTICLITHUB
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/eBook4351",
 			"name" : "eBook4351",
 			"component" : EBOOK4351
 		},
 		{
 			"path" : "/eBook43511",
 			"name" : "eBook43511",
 			"component" : EBOOK43511
 		},
 		{
 			"path" : "/eBook43512",
 			"name" : "eBook43512",
 			"component" : EBOOK43512
 		},
 		{
 			"path" : "/eBook43513",
 			"name" : "eBook43513",
 			"component" : EBOOK43513
 		},
 		{
 			"path" : "/eBook43514",
 			"name" : "eBook43514",
 			"component" : EBOOK43514
 		},
 		{
 			"path" : "/eBook43515",
 			"name" : "eBook43515",
 			"component" : EBOOK43515
 		},
 		{
 			"path" : "/eBook43516",
 			"name" : "eBook43516",
 			"component" : EBOOK43516
 		},
 		{
 			"path" : "/eBook43517",
 			"name" : "eBook43517",
 			"component" : EBOOK43517
 		},
 		{
 			"path" : "/eBook43518",
 			"name" : "eBook43518",
 			"component" : EBOOK43518
 		},
 		{
 			"path" : "/eBook43519",
 			"name" : "eBook43519",
 			"component" : EBOOK43519
 		},
 		{
 			"path" : "/eBook435110",
 			"name" : "eBook435110",
 			"component" : EBOOK435110
 		},
 		{
 			"path" : "/eBook435111",
 			"name" : "eBook435111",
 			"component" : EBOOK435111
 		},
 		{
 			"path" : "/eBook435112",
 			"name" : "eBook435112",
 			"component" : EBOOK435112
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js